<template>
    <div>

        <el-dialog
                title="Select Client, Sitegroup, or Site"
                :visible.sync="selectVisible"
                width="50%"
      >

            <el-tree
                    :data="extents"
                    show-checkbox
                    @check-change="handleCheckChangeChild"
            >
            </el-tree>
            <el-button @click="saveSelection">Save</el-button>
            <el-button @click="cancelSelection">Cancel</el-button>
        </el-dialog>
        <div style="padding:20px;background-color:darkgray;color:white;margin-bottom:20px;">
            <span>Currently working on {{ selected_extent_name}} ({{ selected_extent }}) </span>
            <el-button @click="changeExtent">Change</el-button>
            <el-button>Add New</el-button>
        </div>

    </div>
</template>

<script>

    export default {
        mounted() {
            console.log('Component mounted now.')
            axios.get('/extents')
                .then(response => {
                    this.extents = response.data
                    console.log(this.extents)
                })
                .catch(error => {
                    console.log('oops cats')
                })
            axios.get('/extents/current')
                .then(response => {
                    this.selected_extent = response.data.extent_id
                    this.selected_extent_name = response.data.name
                    console.log('got the following extent as the current extent')
                    console.log(this.selected_extent)
                    console.log('and the following as the name of the current extent')
                    console.log(this.selected_extent_name)
                    this.$emit('checkChange',this.selected_extent)
                })
                .catch(error => {
                    console.log('oops cats')
                })

        },
        data() {
            return {
                extents: '',
                selected_extent: null,
                selected_extent_name: "",
                selectVisible: false
            }
        },
        methods: {
            handleCheckChangeFromElementUiTreeList(data, checked, indeterminate) {
                console.log("data");
                console.log(data);
                console.log("data.label");
                console.log(data.label);
                console.log("checked");
                console.log(checked);
                const regex = /\[(.*)\]$/g;;
                this.selected_extent = regex.exec(data.label)[1];
                console.log("selected id:");
                console.log(this.selected_extent);

            },
            showChangeExtentDialog() {
                this.selectVisible = true;
            },
            saveSelectionInSessionState() {
                axios.post('/extents/current', {
                        current_extent: this.selected_extent
                    }).then(response => {
                        console.log('set the extent session variable')
                    })
                    .catch(error => {
                        console.log('could not set the extent session variable')
                    })
                this.$emit('checkChange',this.selected_extent)
                console.log('emitted the change back to parent')
                this.selectVisible = false
            },
            cancelSelectionDialog() {

            }
        }
    }

</script>
